import { FolderFileKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { GetFolderFileByIdRequest, GetFolderFileByIdResponse } from "@maven-rest/docs/FolderFile.dto";
import { FolderFileUrl } from "@maven-rest/docs/FolderFile.url";

export function useFolderFileByIdQuery(
  req: GetFolderFileByIdRequest,
  options?: SimpleQueryOptions<GetFolderFileByIdResponse, GetFolderFileByIdRequest>
) {
  return useBaseQuery({
    queryKey: [FolderFileKey.FolderFileById, String(req.fileId)],
    fnOption: { url: FolderFileUrl.getFolderFileById(req.fileId) },
    ...options,
  });
}
